import { format } from 'date-fns'
import { Button, FormattedText } from 'src/modules/core/components'
import type { PaymentPausedStatusCardProps } from './payment-paused-status-card.interface'
import classes from './payment-paused-status-card.module.scss'

export function PaymentPausedStatusCard({
  planName,
  price,
  pausedAt,
  onUpdateCard,
  isUpdateCardAvailable,
  isAwaitingUpdate,
}: PaymentPausedStatusCardProps) {
  return (
    <section className={classes.card} data-testid="payment-paused-status-card">
      <div className={classes.stats}>
        <div className={classes.plan}>
          <span className={classes.title}>{planName}</span>
          <span className={classes.caption}>{`$${price}`}</span>
        </div>
        <span className={classes.divider} />
        <div className={classes.plan}>
          <span className={classes.caption}>
            <FormattedText id="dashboard.paused.planCard.pausedLabel" />
          </span>
          <strong className={classes.date}>{pausedAt && format(pausedAt, 'M/d/yyyy')}</strong>
        </div>
      </div>
      <div className={classes.action}>
        <p className={classes.body}>
          <FormattedText id="payment.plans.pausedPlan.body" />
        </p>
        <Button
          className={classes.button}
          widthType="content"
          onClick={onUpdateCard}
          disabled={!isUpdateCardAvailable}
          isLoading={isAwaitingUpdate}
        >
          <FormattedText id="dashboard.paused.planCard.ctaUpdateCard" />
        </Button>
      </div>
    </section>
  )
}
